import apiAxios from "helpers/apiAxios";

// Chữ ký Hub-Sign của chính user đang đăng nhập — Portal API proxy sang Hub-Sign.
const BASE = "/erp/my_signatures";

export const listMySignatures = () => apiAxios.get(BASE).then((r) => r.data);
export const createMySignature = ({ image, label, makeDefault }) =>
  apiAxios.post(BASE, { image, label, make_default: makeDefault }).then((r) => r.data);
export const setDefaultMySignature = (id) => apiAxios.patch(`${BASE}/${id}/default`).then((r) => r.data);
export const deleteMySignature = (id) => apiAxios.delete(`${BASE}/${id}`).then((r) => r.data);
